import React from 'react';

/** 패널 어디를 눌러도 펼친다. 링크, 버튼, 글을 고른 경우는 제외한다 */
export const expandOnClick = (expanded: boolean, onToggle: () => void) => (event: React.MouseEvent) => {
    if (expanded || (event.target as Element).closest('a, button')) return;
    if (!window.getSelection()?.isCollapsed) return;
    onToggle();
};
